import { Grid, Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import { M24_CONFIG_DOC } from "libs/configs/constant";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectM24SwitchMode } from "redux/modules/m24SwitchModeSlice";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: "18px 48px",
    width: 820,
  },
  title: {
    color: theme.palette.darkIndigo.main,
  },
  label: {
    color: "#172b4d",
    height: 34,
  },
  formControl: {
    margin: theme.spacing(1),
    display: "flex",
    flex: 1,
  },
  currencyCode: {
    margin: theme.spacing(1),
    width: 100,
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  buttonUpload: {
    margin: theme.spacing(1),
    height: 54,
    width: 140,
    border: "1px solid rgba(0, 0, 0, 0.23);",
    color: theme.palette.secondary.main,
  },
  uploadStatus: {
    display: "flex",
    flex: 1,
    margin: theme.spacing(1),
    height: 54,
    borderRadius: 7,
    border: "1px solid rgba(0, 0, 0, 0.23);",
    alignItems: "center",
    padding: "0px 17px",
  },
  bulletStatus: {
    width: 18,
    height: 18,
    borderRadius: 18,
    marginRight: theme.spacing(1),
  },
  errorText: {
    marginLeft: theme.spacing(3),
  },
  textBold: {
    color: "#172B4D",
    fontSize: 25,
    fontWeight: "bold",
  },
}));

const menus = [
  {
    title:
      "Permission for foreigner to enter the Kingdom to study investment opportunities",
    value: M24_CONFIG_DOC.INV.CONDITION_TYPE,
  },
  {
    title:
      "Permission for foreigner to enter the Kingdom in case of BOI application is under consideration for investment promotion",

    value: M24_CONFIG_DOC.COM.CONDITION_TYPE,
  },
];

export default function PopupSelectMode({
  value,
  onCancel = () => {},
  onSubmit = () => {},
  onChange = () => {},
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const m24SwitchMode = useSelector(selectM24SwitchMode);

  // const defaultValue =
  //   m24SwitchMode === null || m24SwitchMode === "PENDING" ? "" : m24SwitchMode;

  // useEffect(() => {
  //   onChange(defaultValue);
  // }, [defaultValue]);

  const handleOnChange = (value) => {
    onChange(value.target.value);
  };

  console.log("value ", value);

  return (
    <div className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        QUALIFICATION ENDORSEMENT FOR TEMPORARY 24
      </Typography>
      <Typography variant="h4" color="secondary">
        Qualifications and Criteria
      </Typography>
      <div>
        <Grid container spacing={1} style={{ marginTop: 30 }}>
          <Grid item xs={12}>
            <Typography
              variant="h4"
              color="secondary"
              className={classes.textBold}
            >
              Request
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl
              variant="outlined"
              style={{
                margin: 0,
                marginTop: 8,
              }}
              fullWidth
            >
              <InputLabel>Select</InputLabel>
              <Select label="Select" value={value} onChange={handleOnChange}>
                {menus.map((menu) => (
                  <MenuItem value={menu.value} key={menu.value}>
                    {menu.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} style={{ marginTop: 30 }} />
          <Grid item xs={12} md={4} />
          <Grid item xs={12} md={2}>
            <ColorButton
              size="large"
              fullWidth
              variant="outlined"
              onClick={onCancel}
              disabled={m24SwitchMode === null || m24SwitchMode === "PENDING"}
            >
              Cancel
            </ColorButton>
          </Grid>
          <Grid item xs={12} md={2}>
            <ColorButton
              size="large"
              fullWidth
              variant="contained"
              color="secondary"
              type="submit"
              onClick={onSubmit}
              disabled={!value || value === "PENDING"}
            >
              Next
            </ColorButton>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
